import 'css-chunksrc/client/common/button/styles.scss';export default {
  "button": "_button_epd2n_1",
  "default": "_default_epd2n_20",
  "submit": "_submit_epd2n_29",
  "cancel": "_cancel_epd2n_37",
  "delete": "_delete_epd2n_44",
  "pending": "_pending_epd2n_52",
  "success": "_success_epd2n_56",
  "failure": "_failure_epd2n_64",
  "loader": "_loader_epd2n_72"
};